<template>
  <div class="call-banner">
    <div class="container call-banner__content">
      <img class="call-banner__phone-icon" src="@/assets/icons/cyan-phone.svg" alt="phone icon">
      <p class="call-banner__copy">
        You can also speak to an expert straight away on <a class="link" :href="phoneNumberLink">{{ micPhoneNumberFormatted }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([ 'micPhoneNumberFormatted' ]),
    phoneNumberLink () {
      const normalizedNumber = this.micPhoneNumberFormatted.replace(/\s/g, '')

      return `tel:${normalizedNumber}`
    }
  }
}
</script>

<style lang="scss" scoped>
.call-banner {
  display: flex;
  padding: $spacing-32 $spacing-0;
  background-color: $call-banner-bg;

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__copy {
    margin-bottom: $spacing-0;
    padding-left: $spacing-8;
    font-size: 31px;
    line-height: 1;
    color: $white;

    .link {
      font-weight: bold;
      white-space: nowrap;
    }
  }

  @media (max-width: $screen-md) {
    &__content {
      align-items: flex-start;
    }

    &__phone-icon {
      margin-top: $spacing-4;
      min-width: 25px;
    }

    &__copy {
      padding-left: $spacing-24;
      font-size: 24px;
      line-height: 28px;
      text-align: left;
    }

  }
}
</style>
